// Version information for the application
// In production builds, this is set by the CI/CD pipeline
// In development, it defaults to 'dev'
export const APP_VERSION = process.env.REACT_APP_VERSION || 'dev';
